export default __webpack_public_path__ + "static/media/gallery-hero-bg.7f9aeb70.png";